import { useEffect, type ReactNode } from 'react';
import { X } from 'lucide-react';

/**
 * Форма поверх страницы: на телефоне прилипает к низу (до кнопок дотягивается
 * большой палец), на десктопе — по центру. Escape и тап по фону закрывают.
 */
export default function Sheet({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-ink/40 sm:items-center sm:p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="relative max-h-[92dvh] w-full overflow-y-auto rounded-t-2xl bg-white p-5 pb-[max(1.25rem,env(safe-area-inset-bottom))] shadow-card sm:max-w-md sm:rounded-2xl sm:pb-5"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="absolute right-3 top-3 rounded-lg p-2 text-ink/45 hover:bg-ink/5 hover:text-ink"
          onClick={onClose}
          aria-label="Закрыть"
        >
          <X size={18} />
        </button>
        <h2 className="mb-4 pr-8 text-lg font-semibold">{title}</h2>
        {children}
      </div>
    </div>
  );
}
